module.exports = __webpack_public_path__ + "img/esmeralda-room-2.fa25e6b9.jpg";